
export const parseJWT = (token) => {
    const base64Url = token.split('.')[1]; // Pega o payload do JWT
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Substitui caracteres não padrão
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
            .join('')
    );
    return JSON.parse(jsonPayload);
}